<template>
  <b-overlay :show="busy" rounded="sm">
    <!-- {{ search }}<br /><br />
      {{ item }} -->
    <b-card class="standardpage reports invoices border-none">
      <!-- <b-card-header class="py-1 mb-2">
          <i :class="options.icon" class="text-primary mr-1"></i>
          {{ item.slac }}
          <span class="text-warning"
            >&lt;{{ selection.length == 0 ? "new" : "edit" }}&gt;</span
          >
        </b-card-header> -->
      <div class="availtable datatable text-left">
        <b-card-body class="py-0">
          <b-tabs class="gridtabs">
            <b-tab :active="true">
              <template #title>
                <div class="badgecontainer pr-5">
                  <i :class="options.icon" class="text-primary mr-1"></i>
                  <span class="text-center badgenormal badge-secondary badge-pill">
                    {{ item.surname }}/{{ item.firstname }}
                  </span>
                  <span class="text-warning">&lt;{{ selection.length == 0 ? "new" : "edit" }}&gt;</span>
                </div>
              </template>
              <p class="py-3 px-0">
                <b-row>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Anonymised ID" label-for="key" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.key" placeholder="Enter Anonymised ID"
                          size="sm"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="newid()">
                            <i class="fa fa-refresh"></i>
                          </b-button>
                          <b-button size="sm" variant="outline-secondary" @click="item.key = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label-cols="12" :label="$helpers.requiredlabel(
    requirement_anonymiser,
    'Client SL A/C'
  )
    " :class="$helpers
    .requiredlabel(
      requirement_anonymiser,
      'Client SL A/C'
    )
    .slice(0, 1) == '*'
    ? 'text-danger'
    : ''
    " label-size="sm">
                      <treeselect placeholder="Select slac..." searchPromptText="Type at least 3 chars..."
                        v-model="item.slac" :clearable="true" :async="true" :load-options="treeselect_loadSLAC"
                        :show-count="true" :flatten-search-results="true" :disable-branch-nodes="true"
                        :matchKeys="['id']" search-nested :disabled="false">
                        <div slot="value-label" slot-scope="{ node }">
                          {{ node.raw.id }}
                        </div>
                      </treeselect>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Surname" label-for="surname" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.surname" placeholder="Enter surname"
                          size="sm"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.surname = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="First Name" label-for="firstname" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.firstname" placeholder="Enter first name"
                          size="sm"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.firstname = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Title" label-for="title" label-cols="12" label-size="sm">
                      <treeselect v-model="item.title" :clearable="true" :options="options_title" :disabled="false">
                      </treeselect>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Profile ID" label-for="ref" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.ref" placeholder="Enter Profile ID"
                          size="sm"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.ref = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12">
                    <b-form-group label="Aka (Also Known As SURNAME/FIRSTNAME,...)" label-for="aka" label-cols="12">
                      <b-form-textarea id="aka" v-model="item.aka" placeholder="Aka" rows="2"
                        class="smalltextarea"></b-form-textarea>
                    </b-form-group></b-col>
                </b-row>
                <b-row>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Category" label-for="category" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.category" placeholder="Enter category"
                          size="sm"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.firstname = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Exclude?" label-for="exclude" label-cols="12">
                      <b-form-radio-group id="exclude" v-model="item.exclude" :options="[
    { text: 'No', value: false },
    { text: 'Yes', value: true },
  ]" buttons button-variant="outline-success" size="sm"
                        name="radio-btn-outline"></b-form-radio-group>
                    </b-form-group>
                  </b-col>
                </b-row>
              </p>
            </b-tab>
            <b-tab v-if="idselected">
              <template #title>
                <i class="fa fa-history text-primary mr-1"></i> Audit
              </template>
              <p class="py-3 px-0">
                <b-row>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Created At" label-for="created_at" label-cols="12">
                      <b-input-group>
                        <b-input-group-prepend>
                          <b-form-datepicker size="sm" v-model="item.created_at" button-only label-help=""
                            locale="en-GB" :disabled="true"></b-form-datepicker>
                        </b-input-group-prepend>
                        <b-form-input size="sm" id="date" v-model="item.created_at" type="text" placeholder="YYYY-MM-DD"
                          autocomplete="off" :disabled="true"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.created_at = null"
                            :disabled="true">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Created By" label-for="created_by" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.created_by" placeholder="" size="sm"
                          :disabled="true"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.created_by = ''"
                            :disabled="true">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Updated At" label-for="updated_at" label-cols="12">
                      <b-input-group>
                        <b-input-group-prepend>
                          <b-form-datepicker size="sm" v-model="item.updated_at" button-only label-help=""
                            locale="en-GB" :disabled="true"></b-form-datepicker>
                        </b-input-group-prepend>
                        <b-form-input size="sm" id="date" v-model="item.updated_at" type="text" placeholder="YYYY-MM-DD"
                          autocomplete="off" :disabled="true"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.updated_at = null"
                            :disabled="true">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Updated By" label-for="updated_by" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.updated_by" placeholder="" size="sm"
                          :disabled="true"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.updated_by = ''"
                            :disabled="true">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="ID" label-for="id" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.id" placeholder="" size="sm" :disabled="true">
                        </b-form-input>

                      </b-input-group>
                    </b-form-group>
                  </b-col>
                </b-row>
              </p>
            </b-tab></b-tabs>
        </b-card-body>
        <b-card-footer class="nopadding mt-2">
          <b-row no-gutters>
            <b-col cols="auto" class="text-left mr-3">
              <b-button squared size="sm" variant="primary" @click="saveit">
                <i class="fa fa-check"></i>
                Save It
              </b-button>
            </b-col>
            <b-col class="text-left my-auto">
              <div v-if="busy">
                <i class="fa fa-spinner fa-spin text-primary"></i>
              </div>
              <div v-else>
                <span v-html="message"></span>
              </div>
            </b-col>
            <b-col class="text-right" cols="8">
              <b-button squared size="sm" variant="secondary" class="mr-1" @click="$emit('discard')">
                <i class="fa fa-chevron-left pr-1"></i>
                Back
              </b-button>
            </b-col>
          </b-row>
        </b-card-footer>

      </div>
    </b-card>
  </b-overlay>
</template>

<script>
import { mapGetters } from "vuex";
import gql from "graphql-tag";

import moment from "moment";

export default {
  name: "AnonymiserEdit",
  data() {
    return {
      busy: false,
      requirement_anonymiser: {
        slac: "Client SL A/C",
      },
      options_title: [
        { id: "Mr", label: "Mr" },
        { id: "Mrs", label: "Mrs" },
        { id: "Ms", label: "Ms" },
        { id: "Miss", label: "Miss" },
        { id: "Dr", label: "Dr" },
      ],
      item: {
        id: null,

        title: null,
        firstname: null,
        surname: null,
        slac: null,
        key: null,
        category: null,
        ref: null,
        aka: null,
        exclude: false,
      },
      options: {
        title: "Anonymiser",
        icon: "fa fa-user-secret",
      },
    };
  },
  watch: {
    selection() {
      this.load();
    },
  },
  methods: {
    async load() {
      let variables = {
        id: this.selection[0].id,
        // dateformat: "YYYY-MM-DD",
      };
      console.log("variables", variables);
      try {
        const response = await this.$apollo.query({
          query: gql`
            query anonymiser($id: String) {
              anonymiser(id: $id) {
                id
                key
                slac
                firstname
                surname
                title
                ref
                category
                aka
                exclude
                created_at
                created_by
                updated_at
                updated_by
              }
            }
          `,
          variables,
        });

        if (response.data.anonymiser.length > 0) {
          this.item = response.data.anonymiser[0];
        }
      } catch (error) {
        console.log(error);
      }
      this.busy = false;
    },
    async saveit() {
      let requirement = { ...this.requirement_anonymiser };

      console.log(requirement);

      let requirements = "";
      for (var prop in requirement) {
        if (this.item[prop] == null) {
          requirements += requirement[prop] + ", ";
          // break;
        }
      }
      if (requirements.length > 0) {
        this.message =
          "<span class='text-danger'>" +
          requirements.slice(0, -1) +
          " required field(s). </span>";
        return;
      }
      this.busy = true;

      let variables = { rows: [this.cleanit(this.item)] };
      console.log("variables", variables);

      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation anonymiser_save($rows: [anonymiser_input]) {
              anonymiser_save(rows: $rows) {
                id
                key
                slac
                title
                firstname
                surname
                ref
                category
                aka
                exclude
              }
            }
          `,
          variables,
        });
        console.log(response);
        this.message = "<span class='text-primary'>Saved it.</span>";
      } catch (error) {
        this.message = "<span class='text-danger'>" + error.message + "</span>";
      }

      this.busy = false;
    },

    async newid() {
      console.log("newid");

      try {
        const response = await this.$apollo.query({
          query: gql`
            query anonymiser_id {
              anonymiser_id
            }
          `,
        });
        if (response.data.anonymiser_id.length > 0) {
          this.item.key = response.data.anonymiser_id;
        }
      } catch (error) {
        console.log(error);
      }
    },

    required(e) {

      this.requirement = {
        slac: "Client SL A/C",
      };
    },
  },
};
</script>

<style></style>